import { HomeOutlined, ProductOutlined, UsergroupAddOutlined, AppstoreOutlined, ApartmentOutlined, FundOutlined, DollarOutlined, FileTextOutlined } from "@ant-design/icons";
import { FaShoppingBasket } from "react-icons/fa";
import { MdGroupAdd } from "react-icons/md";
import { MdManageAccounts } from "react-icons/md";
import { roles, rolesConst} from "./others";

export const authLayoutMenu = [
    {
        label: "Dashboard",
        icon: HomeOutlined,
        link: "/",
        allowedRoles: roles
    },
    {
        label: "Produits",
        icon: ProductOutlined,
        link: "/products",
        allowedRoles: [rolesConst.SuperAdmin]
    },
    {
        label: "Commandes",
        icon: FaShoppingBasket,
        link: "/orders",
        allowedRoles: roles,
    },
    {
        label: "Employeurs",
        icon: UsergroupAddOutlined,
        link: "/users",
        allowedRoles: [rolesConst.SuperAdmin]
    },
    {
        label: "Société",
        icon: AppstoreOutlined,
        link: "/delivery-company",
        allowedRoles: [rolesConst.SuperAdmin]
    },
    {
        label: "Mapping Feuilles",
        icon: FileTextOutlined,
        link: "/sheet-mapping",
        allowedRoles: [rolesConst.SuperAdmin]
    },
    {
        label: "Commandes Feuilles",
        icon: FileTextOutlined,
        link: "/sheet-orders",
        allowedRoles: [rolesConst.SuperAdmin, rolesConst.ConfirmationConvertion, rolesConst.Management]
    },
    {
        label: "Subordonnés",
        icon: ApartmentOutlined,
        link: "#",
        allowedRoles: [rolesConst.SuperAdmin],
        children: [
            {
                label: "Managers",
                icon: MdGroupAdd,
                link: "/managers",
                allowedRoles: [rolesConst.SuperAdmin]
            },
            {
                label: "Comptes",
                icon: MdManageAccounts,
                link: "/accounts",
                allowedRoles: [rolesConst.SuperAdmin]
            }
        ]
    },
    {
        label: "Statistiques",
        icon: FundOutlined,
        link: "/statistics",
        allowedRoles: roles
    },
    {
        label: "Paiement",
        icon: DollarOutlined,
        link: "",
        allowedRoles: [rolesConst.SuperAdmin,rolesConst.Deliveryman],
        children: [
            {
                label: "Confirmation",
                link: "/payment-confirmation",
                allowedRoles: [rolesConst.SuperAdmin, rolesConst.ConfirmationConvertion,rolesConst.ConfirmationInstagram, rolesConst.ConfirmationMessenger, rolesConst.ConfirmationWhatsApp]
            },
            {
                label: "Gestion",
                link: "/payment-management",
                allowedRoles: [rolesConst.SuperAdmin, rolesConst.Management]
            },
            {
                label: "Suivie",
                link: "/payment-fallow",
                allowedRoles: [rolesConst.SuperAdmin, rolesConst.Follow]
            },
            {
                label: "Liveur",
                link: "/payment-deliveryman",
                allowedRoles: [rolesConst.Deliveryman,rolesConst.SuperAdmin]
            },
        ]
    },
    {
        label: "Spend",
        icon: DollarOutlined,
        link: "/spend",
        allowedRoles: [rolesConst.SuperAdmin]
    },
]
